module.exports = __webpack_public_path__ + "static/img/gaozhonglishi10.a7d59c40.jpg";